import type { Amount, OrderSide } from '@/legacy-api/orders-slice.gen'

export enum AllocationCheckStatus {
  CREATED = 'created',
  SUBMITTED = 'submitted',
  ACCEPTED = 'accepted',
  FAILED = 'failed',
}

export enum LPLSubFirm {
  LPLE = 'LPLE',
  LPLF = 'LPLF',
  EQHA = 'EQHA',
}

export enum AllocationCheckLevel {
  SOFT = 'soft',
  HARD = 'hard',
}

export interface Check {
  level: AllocationCheckLevel
  reason: string
}

export interface AllocationCheck {
  account_id: string
  checks: Check[]
  client_allocation_id: string
  error_message: string
  instrument_id: string
  quantity: Amount
  request_id: string
  side: OrderSide
  status: AllocationCheckStatus
  subfirm: LPLSubFirm | null
}

interface CreateEditChecksRequestAllocation {
  client_allocation_id: string
  account_id: string
  instrument_id: string
  quantity: Amount
  side: OrderSide
  price: number | null
  annotation: string
}

export interface CreateEditChecksRequest {
  allocations: CreateEditChecksRequestAllocation[]
}

export interface CreateEditChecksResponse {
  id: string
}

export interface GetEditChecksResponse {
  allocation_checks: AllocationCheck[]
}
